import { SafeResourceUrl } from '@angular/platform-browser';
import { UserRole } from '../stammdaten/benutzer/benutzer';

export class Hilfe {
    hilfe_id: number;
    route_url: string;
    projekt: string;
    hilfe_reiter: HilfeReiter[] = [];

    constructor(prjkt: string, gesamteUrl: string) {
        this.projekt = prjkt;
        this.route_url = Hilfe.urlAufbereiten(gesamteUrl);
    }

    public static urlAufbereiten(gesamteUrl: string): string {
        let tab = '';
        if (gesamteUrl.includes('?')) {
            const [baseUrl, queryString] = gesamteUrl.split('?');
            // Suche nach dem 'tab'-Parameter und behalte nur diesen
            const params = new URLSearchParams(queryString);
            if (params.has('tab')) {
                tab = '?tab=' + params.get('tab');
            }
        }

        const i = gesamteUrl.indexOf('?');
        if (i > 0) {
            gesamteUrl = gesamteUrl.substring(0, i);
        }

        const regex2 = /\b\d+\b/g;
        let match2: string[];
        while ((match2 = regex2.exec(gesamteUrl)) !== null) {
            gesamteUrl = gesamteUrl.replace(match2[0], ':id');
        }

        return gesamteUrl + tab;
    }
}

export class HilfeDialogInput {
    hilfe: Hilfe;

    constructor(h: Hilfe) {
        this.hilfe = h;
    }
}

export class HilfeDialogResult {
    hilfe: Hilfe;
    confirm: boolean;
}

export class HilfeReiter {
    hr_id: number;
    titel: string;
    hilfeseite_url: string;
    benutzerrollen: UserRole[] = [];
    sichereUrl?: SafeResourceUrl; // URL des iFrames
    showIframe?: boolean; // Soll der iframe angezeigt werden?
}

export class HilfeReiterBackend {
    titel: string;
    hilfeseite_url: string;
    benutzerrollen: UserRole[];
}

export class HilfeBackend {
    hilfe_id: number;
    route_url: string;
    projekt: string;
    hilfe_reiter: HilfeReiterBackend[];
}
